export const ERROR_CODE_100 =
  "Your request cannot be completed at this time, ‘Contact Us’ and we will assist you with the profile creation.";
export const ERROR_CODE_101 =
  "You already have created a profile on Supplier Central. <a class='text-customBlue underline' href='/login'>Switch to Log In</a>";
export const ERROR_CODE_102 = "Invalid Access Code";
export const SUCCESS_MSG_ACCESS_CODE_SENT =
  "A one-time access code has been sent to the email you provided. ";
export const SUCCESS_MSG_ACCESS_CODE_RESENT =
  "A new access code has been sent to the email you provided. ";
export const VALIDATION_STATUS_SUCCESS = "SUCCESS";
export const VALIDATION_STATUS_FAILED = "FAILED";
export const ERROR_CODE_NO_MATCHING_EMAIL = "100";
export const ERROR_CODE_USER_ALREADY_EXISTS = "101";
export const ERROR_CODE_WRONG_OTP = "102";
export const ERROR_CODE_INVALID_SESSION = "SC029";
export const ERROR_CODE_SESSION_EXISTS = "SC030";

export const RESPONSE_TYPE = {
  Success: "SUCCESS",
  Failed: "FAILED",
  PartialSuccess: "PARTIAL_SUCCESS",
};

export const MESSAGE_TYPE = {
  EmailVerifySuccess: "EMAIL_VEFIRY_SUCCESS",
  InCorrectAccessCode: "INCORRECT_ACCESS_CODE",
  ResendAccessCodeSuccess: "RESEND_ACCESS_CODE_SUCCESS",
};
// prettier-ignore
export const NOTIFICATION_MESSAGES = {
  [MESSAGE_TYPE.EmailVerifySuccess]: "A one-time access code has been sent to the email you provided. ",
  [MESSAGE_TYPE.InCorrectAccessCode]: "The access code you entered is incorrect or you access is not permitted at this time.",
  [MESSAGE_TYPE.ResendAccessCodeSuccess]: "A new access code has been sent to the email you provided."
};
